import { Link } from 'react-router-dom';

import { DataTable, type Column } from '../components/DataTable.tsx';
import { Pagination } from '../components/Pagination.tsx';
import { dateOnly, money, statusClass, statusLabel } from '../lib/format.ts';
import { usePaginatedList } from '../lib/usePaginatedList.ts';

interface Row {
  id: number;
  csNo: string;
  csDate: string;
  customerNo: string | null;
  customerName: string | null;
  salesman: string | null;
  currency: string;
  value: number;
  status: string;
}

export function CashSalesListPage() {
  const list = usePaginatedList<Row>({
    endpoint: '/api/dashboard/cash-sales',
    defaultSortColumn: 'cs_date',
    defaultSortDirection: 'DESC',
  });
  const columns: Column<Row>[] = [
    { key: 'cs_no', label: 'CS no', sortable: true, className: 'mono', render: (r) => <Link to={`/cash-sales/${encodeURIComponent(r.csNo)}`}>{r.csNo}</Link> },
    { key: 'cs_date', label: 'Date', sortable: true, className: 'mono', render: (r) => dateOnly(r.csDate) },
    { key: 'customer_no', label: 'Customer', sortable: true, render: (r) => r.customerNo ? <Link to={`/customers/${encodeURIComponent(r.customerNo)}`}>{r.customerName ?? r.customerNo}</Link> : '—' },
    { key: 'salesman', label: 'Salesman', render: (r) => r.salesman ?? '—' },
    { key: 'value', label: 'Value', sortable: true, className: 'num', render: (r) => money(r.value, r.currency) },
    { key: 'status', label: 'Status', sortable: true, render: (r) => <span className={`badge ${statusClass(r.status)}`}>{statusLabel(r.status)}</span> },
  ];
  return (
    <>
      <header className="main-header">
        <h1 className="main-title">Cash sales</h1>
        <span className="main-subtitle">{list.data ? `${list.data.total} total` : ''}</span>
      </header>
      <div className="toolbar">
        <input placeholder="Search CS no or ref…" defaultValue={list.state.search} onChange={(e) => list.setSearch(e.target.value)} />
      </div>
      {list.error && <div className="error">{(list.error as Error).message}</div>}
      {list.isLoading && !list.data && <div className="loading">Loading…</div>}
      {list.data && (
        <>
          <DataTable columns={columns} rows={list.data.rows} rowKey={(r) => r.id} sortColumn={list.state.sortColumn} sortDirection={list.state.sortDirection} onSortChange={list.toggleSort} />
          <Pagination page={list.state.page} pageSize={list.state.pageSize} total={list.data.total} onPageChange={list.setPage} />
        </>
      )}
    </>
  );
}
